var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9438 15.956V18.956C20.9449 19.2345 20.8879 19.5102 20.7763 19.7653C20.6647 20.0205 20.5011 20.2496 20.2959 20.4379C20.0906 20.6261 19.8484 20.7695 19.5845 20.8587C19.3207 20.9479 19.0412 20.9811 18.7638 20.956C15.6866 20.6216 12.7308 19.5701 10.1338 17.886C7.71761 16.3507 5.66912 14.3022 4.13378 11.886C2.44376 9.27719 1.39202 6.30698 1.06378 3.21599C1.03879 2.93945 1.07166 2.66075 1.16028 2.39761C1.24891 2.13447 1.39135 1.89267 1.57855 1.68761C1.76574 1.48254 1.99359 1.31869 2.24757 1.20651C2.50156 1.09432 2.77612 1.03625 3.05378 1.03599H6.05378C6.53909 1.03121 7.00957 1.20306 7.37754 1.51952C7.74551 1.83597 7.98586 2.27543 8.05378 2.75599C8.1804 3.71605 8.41523 4.65871 8.75378 5.56599C8.88832 5.92391 8.91744 6.3129 8.83769 6.68687C8.75793 7.06083 8.57264 7.4041 8.30378 7.67599L7.03378 8.94599C8.45734 11.4495 10.5302 13.5224 13.0338 14.946L14.3038 13.676C14.5757 13.4071 14.9189 13.2218 15.2929 13.1421C15.6669 13.0623 16.0559 13.0914 16.4138 13.226C17.3211 13.5645 18.2637 13.7994 19.2238 13.926C19.7095 13.9945 20.1532 14.2392 20.4703 14.6135C20.7874 14.9878 20.9559 15.4656 20.9438 15.956Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.504e160184b5a58348d9f4af8e342f69.svg";
export { ForwardRef as ReactComponent };